
  import { Vue, Component, Emit, Model, Prop } from 'vue-property-decorator';
  import { ReceivedMeals, MealCountCalcs } from "@/models";
  import { data } from './mc-clicker.data';
  import { clone } from '@/utils';

  @Component
  export default class McClickerTests extends Vue {
    

    testCount = clone<ReceivedMeals>(data.receivedMeals);
    testLabels = data.testLabels;

    created() {
    }

    mounted() {
    }
  }
